import httpService from "./httpService";
import utils from "./utils";

export default {
    findById(id) {
        return httpService.get("document/" + id, null);
    },

    // Lấy danh sách tài liệu
    getListDocument(usingAdvanceSearch, keyword, typeId, form, pageable) {
        let params = utils.merge({
            advanceSearch: usingAdvanceSearch ? true : null,
            keyword,
            typeId
        }, pageable);
        return httpService.post("document/search", usingAdvanceSearch ? form : {}, { params });
    },

    // Lấy danh sách lịch sử
    getHistoryByDocId(docId, pageable) {
        let params = { ...pageable, docId };
        return httpService.get("document/search/history", { params });
    },

    // Thêm mới tài liệu
    save(form) {
        return httpService.post(`document/create`, form);
    },

    // Sửa tài liệu
    update(id, form) {
        return httpService.put(`/document/update/${id}`, form);
    },

    // Phê duyệt tài liệu
    approve(id) {
        return httpService.post(`/document/approve/${id}`);
    },

    // Từ chối tài liệu
    reject(id) {
        return httpService.post(`/document/reject/${id}`);
    },

    // Xóa tài liệu
    delete(id) {
        return httpService.delete(`document/${id}`);
    },

    // Check quyền quản lý tài liệu
    getPermission() {
        return httpService.get("document/check");
    }
}



// WEBPACK FOOTER //
// ./src/services/documentService.js